<template>
    <v-container id="faq" class="py-12">
        <homepage-title>Frequently Asked Questions</homepage-title>

        <v-expansion-panels popout focusable mandatory class="mt-8">
            <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                    Kenapa memilih Ukom Nakes?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="my-4">
                        Ukom Nakes adalah platform try-out kedokteran gigi terbaik yang menyediakan soal yang berkualitas, menyesuaikan silabus UKMP2DG. Harga yang murah dengan kualitas nomor SATU!.  Menyesuaikan dengan kantong mahasiswa ya gengs!
                    </p>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                    Apa kelebihan tryout di Ukom Nakes?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="my-4">
                        Try out Ukom Nakes merupakan try out yang sangat berkualitas karena:
                        <ol>
                            <li>
                                Try out terdiri dari 10x try out masing-masing terdiri dari 120 soal dengan topik yang paling sering keluar di UKMP2DG!
                            </li>
                            <li>
                                Pembahasan lengkap dan menarik, terdapat grafik pendalaman yang bisa bantu kamu lebih paham kebutuhan belajar kamu!
                            </li>
                            <li>
                                Tampilan aplikasi yang menarik dan dapat diakses di playstore yang membantu kamu bisa mengerjakan dengan gadget!
                            </li>
                        </ol>
                    </p>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                    Apakah bisa mencoba tryout secara gratis?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="my-4">
                        Ada try-out sampel yang bisa kamu kerjain!
                    </p>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                    Pertanyaan lain?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p class="my-4">
                        Kamu bisa menghubungi kontak yang ada di bawah. Kami senang membantumu!
                    </p>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
import HomepageTitle from './HomepageTitle'

export default {
    components: {
        HomepageTitle,
    },
}
</script>
